// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__ZO2Rj","tab":"ProcedureTabs_tab__1M2Uz"};